import React, { useMemo, useState } from 'react';
import { useProducts } from '../ProductContext';
import { downloadCsv, exportTableToPdf } from '../utils/reportExport';
import './ReportPages.css';
import ReportFooter from '../components/ReportFooter';

const ReportStockPage = ({ onNavigate }) => {
  const { products, pendingProducts } = useProducts();
  const [categoryFilter, setCategoryFilter] = useState('all');
  const lowStock = (products || []).filter((p) => typeof p.quantity === 'number' && p.lowStockLimit != null && p.quantity <= p.lowStockLimit);
  const categories = useMemo(() => ['all', ...Array.from(new Set((products || []).map((p) => p.category).filter(Boolean)))], [products]);
  const filteredProducts = useMemo(() => (products || []).filter((p) => categoryFilter === 'all' || p.category === categoryFilter), [products, categoryFilter]);
  const stockValue = (products || []).reduce((sum, p) => sum + (Number(p.quantity) || 0) * (Number(p.purchasingPrice) || 0), 0);

  return (
    <div className="report-shell">
      <div className="report-back"><button type="button" onClick={() => onNavigate('reports')}>← All reports</button></div>
      <div className="report-title-center">
        <h1>Stock Report</h1>
      </div>
      <p className="muted">Approved products, stock valuation, and low stock alerts.</p>
      <div className="report-toolbar">
        <div className="field"><label>Category</label><select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>{categories.map((c)=><option key={c} value={c}>{c === 'all' ? 'All' : c}</option>)}</select></div>
        <div className="report-actions">
          <button
            type="button"
            onClick={async () => {
              try {
                await exportTableToPdf(
                  'Stock Report',
                  ['Name', 'Category', 'Quantity', 'Purchase Price', 'Selling Price', 'Low Limit'],
                  filteredProducts.map((p) => [
                    p.name,
                    p.category,
                    p.quantity,
                    p.purchasingPrice,
                    p.sellingPrice,
                    p.lowStockLimit ?? '-',
                  ]),
                  {
                    subtitle: 'Inventory health and valuation snapshot',
                    criteria: [`Category: ${categoryFilter}`],
                    summary: [
                      { label: 'Products', value: (products?.length || 0).toLocaleString() },
                      { label: 'Stock value', value: `TZS ${Math.round(stockValue).toLocaleString()}` },
                      { label: 'Pending approvals', value: (pendingProducts?.length || 0).toLocaleString() },
                      { label: 'Low stock alerts', value: lowStock.length.toLocaleString() },
                    ],
                  }
                );
              } catch (e) {
                console.error(e);
              }
            }}
          >
            Export PDF
          </button>
          <button type="button" onClick={() => downloadCsv('stock-report.csv', [['Name','Category','Quantity','Purchase Price','Selling Price','Low Limit'], ...filteredProducts.map((p)=>[p.name,p.category,p.quantity,p.purchasingPrice,p.sellingPrice,p.lowStockLimit ?? ''])])}>Export Excel</button>
        </div>
      </div>
      <div className="report-grid-cards">
        <div className="report-stat"><span>Total products</span><strong>{products?.length || 0}</strong></div>
        <div className="report-stat"><span>Stock value</span><strong>TZS {stockValue.toLocaleString()}</strong></div>
        <div className="report-stat"><span>Pending approvals</span><strong>{pendingProducts?.length || 0}</strong></div>
        <div className="report-stat"><span>Low stock alerts</span><strong>{lowStock.length}</strong></div>
      </div>
      <ReportFooter />
    </div>
  );
};

export default ReportStockPage;
